// World objects data - positions of all NPCs across the island
// NPC positions spread across the 5 zones of the square island

export const WORLD_OBJECTS = [
  // === CENTER ZONE (Stage 1) - 5 NPCs: farmer, baker, teacher, doctor, artist ===
  { id: 1001, type: 'npc', x: 0, y: -2000, npcId: 'farmer', collision: false },
  { id: 1002, type: 'npc', x: -3500, y: 1500, npcId: 'baker', collision: false },
  { id: 1003, type: 'npc', x: 4000, y: -1000, npcId: 'teacher', collision: false },
  { id: 1004, type: 'npc', x: -2000, y: -4000, npcId: 'doctor', collision: false },
  { id: 1005, type: 'npc', x: 3000, y: 3500, npcId: 'artist', collision: false },
  
  // === NORTH ZONE (Stage 2) - 5 NPCs ===
  { id: 2001, type: 'npc', x: 0, y: -11200, npcId: 'explorer', collision: false, zone: 'NORTH' },
  { id: 2002, type: 'npc', x: -4800, y: -13600, npcId: 'chef', collision: false, zone: 'NORTH' },
  { id: 2003, type: 'npc', x: 3200, y: -9600, npcId: 'musician', collision: false, zone: 'NORTH' },
  { id: 2004, type: 'npc', x: -2400, y: -10800, npcId: 'librarian', collision: false, zone: 'NORTH' },
  { id: 2005, type: 'npc', x: 5600, y: -12000, npcId: 'gardener', collision: false, zone: 'NORTH' },
  
  // === EAST ZONE (Stage 3) - 5 NPCs ===
  { id: 3001, type: 'npc', x: 11200, y: 0, npcId: 'police', collision: false, zone: 'EAST' },
  { id: 3002, type: 'npc', x: 9600, y: -2400, npcId: 'builder', collision: false, zone: 'EAST' },
  { id: 3003, type: 'npc', x: 13200, y: 1800, npcId: 'dancer', collision: false, zone: 'EAST' },
  { id: 3004, type: 'npc', x: 10400, y: 4000, npcId: 'athlete', collision: false, zone: 'EAST' },
  { id: 3005, type: 'npc', x: 14000, y: -3200, npcId: 'astronaut', collision: false, zone: 'EAST' },
  
  // === SOUTH ZONE (Stage 4) - 5 NPCs ===
  { id: 4001, type: 'npc', x: 0, y: 11200, npcId: 'scientist', collision: false, zone: 'SOUTH' },
  { id: 4002, type: 'npc', x: -3600, y: 9600, npcId: 'pilot', collision: false, zone: 'SOUTH' },
  { id: 4003, type: 'npc', x: 4400, y: 10400, npcId: 'firefighter', collision: false, zone: 'SOUTH' },
  { id: 4004, type: 'npc', x: -2000, y: 12800, npcId: 'vet', collision: false, zone: 'SOUTH' },
  { id: 4005, type: 'npc', x: 5600, y: 13200, npcId: 'postie', collision: false, zone: 'SOUTH' },
  
  // === WEST ZONE (Stage 5) - 5 NPCs ===
  { id: 5001, type: 'npc', x: -11200, y: 0, npcId: 'zookeeper', collision: false, zone: 'WEST' },
  { id: 5002, type: 'npc', x: -9600, y: -2800, npcId: 'magician', collision: false, zone: 'WEST' },
  { id: 5003, type: 'npc', x: -12800, y: 2400, npcId: 'police', collision: false, zone: 'WEST' },
  { id: 5004, type: 'npc', x: -10400, y: 4400, npcId: 'builder', collision: false, zone: 'WEST' },
  { id: 5005, type: 'npc', x: -14000, y: -1200, npcId: 'dancer', collision: false, zone: 'WEST' },
  
  // === LANDMARK BUILDINGS ===
  // Center Zone
  { id: 6001, type: 'hut', x: 1500, y: -800, collision: true, collisionRadius: 80, landmark: true },
  { id: 6002, type: 'campfire', x: 500, y: 800, collision: false, landmark: true },
  // North Zone - Lighthouse
  { id: 6010, type: 'pine', x: -2000, y: -9000, collision: true, collisionRadius: 40, zone: 'NORTH' },
  { id: 6011, type: 'pine', x: 2800, y: -11000, collision: true, collisionRadius: 40, zone: 'NORTH' },
  { id: 6012, type: 'tree', x: -4000, y: -10500, collision: true, collisionRadius: 50, zone: 'NORTH' },
  // East Zone - Market District
  { id: 6020, type: 'house', x: 12000, y: 2000, collision: true, collisionRadius: 100, zone: 'EAST' },
  { id: 6021, type: 'tree', x: 10800, y: 1200, collision: true, collisionRadius: 50, zone: 'EAST' },
  // South Zone - Town Hall District
  { id: 6030, type: 'office', x: 1000, y: 10000, collision: true, collisionRadius: 100, zone: 'SOUTH' },
  { id: 6031, type: 'tree', x: -1500, y: 11500, collision: true, collisionRadius: 50, zone: 'SOUTH' },
  // West Zone - Library & Park
  { id: 6040, type: 'house', x: -10000, y: 1800, collision: true, collisionRadius: 100, zone: 'WEST' },
  { id: 6041, type: 'bush', x: -11500, y: 3000, collision: false, zone: 'WEST' },
  { id: 6042, type: 'rock', x: -12000, y: -800, collision: true, collisionRadius: 30, zone: 'WEST' },
  
  // Scattered scenery across the island
  { id: 7001, type: 'tree', x: -2800, y: -2200, collision: true, collisionRadius: 50 },
  { id: 7002, type: 'pine', x: 2200, y: -3000, collision: true, collisionRadius: 40 },
  { id: 7003, type: 'bush', x: -1200, y: 2500, collision: false },
  { id: 7004, type: 'rock', x: 3500, y: 1800, collision: true, collisionRadius: 30 },
  { id: 7005, type: 'tree', x: -4500, y: -500, collision: true, collisionRadius: 50 },
  { id: 7006, type: 'pine', x: 1800, y: 4200, collision: true, collisionRadius: 40 },
  { id: 7007, type: 'bush', x: -800, y: -3800, collision: false },
  { id: 7008, type: 'rock', x: 4800, y: -4500, collision: true, collisionRadius: 30 },
];

// Legacy function for compatibility
export const generateWorldObjects = (stage = 1) => WORLD_OBJECTS;

export const INITIAL_WORLD_OBJECTS = WORLD_OBJECTS;
